import Rollbar from 'rollbar';

const rollbar = new Rollbar({
    accessToken: 'b0ae75bd888e435d980739205e12b012',
    environment: 'testenv',
    captureUncaught: true,
    captureUnhandledRejections: true,
});

export default rollbar;
